var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"auto_start":false,"fields":_vm.fields,"table_store":"call-tracking/stats/table"}})}
var staticRenderFns = []

export { render, staticRenderFns }